/**
 * Share Feedback Button Component
 * Button to open feedback modal for the most recent AI message
 */

import React, { useContext } from 'react';

import { TranscriptContext } from '../../../../store/transcript/store';
import { MESSAGE_ROLE } from '../../../Message/types/messages';
import { useOcFabWidgetOptions } from '../../contexts/OcFabWidgetOptionsContext';
import { useFeedbackContext } from './FeedbackProvider';
import { FeedbackButton } from './ShareFeedbackButton.styled';

/**
 * ShareFeedbackButton Component
 * Displays a button to share beta feedback on the most recent AI response
 * Only shows after user has received a real AI response (not initial message)
 */
export const ShareFeedbackButton: React.FC = () => {
  const { state } = useContext(TranscriptContext);
  const { openFeedbackModal } = useFeedbackContext();
  const { feedbackButtonText } = useOcFabWidgetOptions();

  // Get the most recent AI assistant message that's not the initial message
  const mostRecentAiMessage = [...state.messages]
    .reverse()
    .find((m) => m.role === MESSAGE_ROLE.ASSISTANT && m.messageId !== state.initialMessage?.messageId);

  const messageKey = mostRecentAiMessage?.messageId || '';

  // Don't render button until there's a real AI response
  if (!messageKey) {
    return null;
  }

  const handleClick = () => {
    openFeedbackModal(messageKey);
  };

  return (
    <FeedbackButton type="button" onClick={handleClick}>
      <span className="ai-button-text">{feedbackButtonText}</span>
    </FeedbackButton>
  );
};

export default ShareFeedbackButton;

